/* SYLVI: Judge.me long-review "View more" enhancer. Kept separate from custom.js
   so it still runs if older theme scripts throw before the review block. */
(function () {
  if (window.SylviJudgeMeReadMore) return;
  window.SylviJudgeMeReadMore = true;

  var REVIEW_SELECTOR = '.jdgm-rev-widg__reviews .jdgm-rev';
  var TOGGLE_CLASS = 'jdgm-review-toggle';
  var LONG_REVIEW_LENGTH = 220;
  var scheduled = null;

  function needsToggle(review, body) {
    var text = (body.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length > LONG_REVIEW_LENGTH) return true;

    var wasExpanded = review.classList.contains('is-expanded');
    var collapsedHeight = body.getBoundingClientRect().height;

    review.classList.add('is-expanded');
    var expandedHeight = body.getBoundingClientRect().height;
    if (!wasExpanded) review.classList.remove('is-expanded');

    return expandedHeight > collapsedHeight + 4;
  }

  function enhanceReview(review) {
    if (!review || review.getAttribute('data-sylvi-readmore') === 'true') return;

    var body = review.querySelector('.jdgm-rev__body');
    if (!body) return;

    review.setAttribute('data-sylvi-readmore', 'true');
    review.classList.remove('is-expanded');

    requestAnimationFrame(function () {
      if (!document.documentElement.contains(review)) return;

      if (!needsToggle(review, body)) {
        review.classList.add('jdgm-rev--no-toggle');
        return;
      }

      review.classList.add('jdgm-rev--has-toggle');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = TOGGLE_CLASS;
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'View more';
      body.insertAdjacentElement('afterend', button);
    });
  }

  function enhanceReviews(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(REVIEW_SELECTOR).forEach(enhanceReview);
  }

  function scheduleEnhance() {
    clearTimeout(scheduled);
    scheduled = setTimeout(function () { enhanceReviews(document); }, 120);
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('.' + TOGGLE_CLASS) : null;
    if (!button) return;

    var review = button.closest('.jdgm-rev');
    if (!review) return;

    var expanded = review.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded ? 'View less' : 'View more';
  });

  function initReviewToggles() {
    enhanceReviews(document);

    if (!document.body || !window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('.jdgm-rev, .jdgm-rev-widg__reviews')) ||
            (node.querySelector && node.querySelector('.jdgm-rev'))
          ) {
            scheduleEnhance();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewToggles);
  } else {
    initReviewToggles();
  }
})();
